<div class="scrollable-component">
	<div class="container">
		<div class="row">
			<div class="col-12">
				<div class="card">
					<p-toast></p-toast>
					<p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
					<p-table
						#dt
						[value]="integrations"
						dataKey="id"
						[tableStyle]="{'min-width': '50rem'}"
						[paginator]="true"
						[rows]="10"
						[showCurrentPageReport]="true"
						currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
						[rowsPerPageOptions]="[10, 25, 50]"
						[styleClass]="'p-datatable-sm'"
						[globalFilterFields]="['name']"
					>
						<ng-template pTemplate="caption">
							<div class="row">
								<div class="col-md-12 text-center">
									<h4 class="mt-2">Integrations List</h4>
								</div>
							</div>
							<div class="row">
								<div class="flex col-md-6">
									<span class="p-input-icon-left ml-auto">
										<i class="pi pi-search"></i>
										<input [(ngModel)]="searchField" pInputText type="text" class="p-inputtext-sm" (input)="applyGlobalFilter($event, dt)" placeholder="Search" />
									</span>
								</div>
							</div>
						</ng-template>
						<ng-template pTemplate="header">
							<tr>
								<th
									pSortableColumn="name"
								>
									Integration <p-sortIcon field="name"></p-sortIcon>
								</th>
								<th>Actions</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-integration>
							<tr [ngSwitch]="currentSection">
								<td>{{ integration.name }}</td>
								<!-- Product Identifier Section -->
								<td *ngSwitchCase="'product-identifier'">
									<p-button
										[icon]="'pi pi-pencil'"
										[styleClass]="'p-button-rounded p-button-text'"
										(click)="editProductIdentifier(integration.name)"
									></p-button>
								</td>
								<!-- Client-identifier Section -->
								<td *ngSwitchDefault>
									<p-button
										[icon]="'pi pi-pencil'"
										[styleClass]="'p-button-rounded p-button-text'"
										(click)="editIntegration(integration.name)"
									></p-button>
								</td>
							</tr>
						</ng-template>
					</p-table>
				</div>
			</div>
		</div>
	</div>
</div>